import { useCanGoBack, useRouter } from "@tanstack/react-router";
import type { ReactNode } from "react";

/** The one look every screen's way back shares — above the content, not in it. */
export const BACK_LINK_CLASS = "w-fit text-xs text-muted-foreground hover:text-foreground";

/**
 * Back to where the reader came from, the way the artifact leans on browser
 * history — a filtered list, a Matrix, a run log. Only when there is nothing
 * to go back to (a pasted link, a fresh tab) does the screen's own
 * `fallback` link show instead, naming where it goes.
 */
export function BackLink({ fallback }: { fallback: ReactNode }) {
  const canGoBack = useCanGoBack();
  const router = useRouter();
  if (!canGoBack) return <>{fallback}</>;
  return (
    <button type="button" className={BACK_LINK_CLASS} onClick={() => router.history.back()}>
      ← 뒤로
    </button>
  );
}
